<div>
    <h1 style="color: red; font-family: 'Poppins', sans-serif; font-weight: bold;">Atenção</h1>
    <p>Alguns de seus contratos estão prestes a vencer, entre em contato com o suporte Agtech para executar a renovação ;)</p>
    <p>Os seguintes contratos estão em aviso:</p>
    <mat-accordion>
        <mat-expansion-panel hideToggle *ngFor="let contrato of contratos">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{contrato.produto}}
                </mat-panel-title>
                <mat-panel-description>
                    Clique para mais detalhes
                </mat-panel-description>
            </mat-expansion-panel-header>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Cliente</th>
                        <th scope="col">Data do vencimento</th>
                        <th scope="col">Dias restantes</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let dado of contrato.contratos">
                        <td scope="row">{{dado.nome_cliente}}</td>
                        <td>{{dado.ts_data_vencimento | date: "dd/MM/yyyy"}}</td>
                        <td>{{dado.diasFaltantes}} dias</td>
                    </tr>
                </tbody>
            </table>
        </mat-expansion-panel>
    </mat-accordion>
    <form [formGroup]="confirmacao">
        <section class="example-section">
            <mat-checkbox formControlName="ciente">Estou ciente da(s) data(s) de vencimento do(s) contrato(s)</mat-checkbox>
        </section>
    </form>
    <button [disabled]="flag" [class.disabled]="flag==true" (click)="confirmacaoAviso()">Confirmar</button>
</div>